<script>
   /*************************************************************/
   /* PlotVariance                                              */
   /* --------------------                                      */
   /* shows plot with variance values vs. number of PCs         */
   /*************************************************************/

   import { XAxis, YAxis, Box } from 'svelte-plots-basic/2d';
   import { vector } from 'mdatools/arrays';
   import { min } from 'mdatools/stat';
   import { FACE_COLORS } from './Defaults.js';

   import PlotSeries from './PlotSeries.svelte';
   import Axes from './Axes.svelte';

   let {
      params,                        // JSON with main plot parameters
      callbacks,                     // JSON with all callback methods
      props,                         // JSON with main properties (model, results, dataset)
      selected,                      // ID of selected object
   } = $props();

   // get the parameters needed for the plot
   let res = $derived(props ? props.res : null);
   let resobj = $derived(res ? res[params.resID] : null);


   /*****************************************/
   /* Component code                        */
   /*****************************************/

   // constant plot parameters
   const titles = {
      'expvar': 'Explained variance',
      'resvar': 'Residual variance',
      'cumexpvar': 'Cumulative explained variance',
      'cumresvar': 'Cumulative residual variance'
   };

   const varForm = $derived(params.varForm === 'cumulative' ? 'cum' : '');
   const varType = $derived(params.varType === 'explained' ? 'exp' : 'res');
   const statName = $derived(varForm + varType + 'var');
   const title = $derived(titles[statName]);

   const xMin = $derived(resobj.ncomp > 1 ? 1 - resobj.ncomp * 0.065 : -0.1);
   const xMax = $derived(resobj.ncomp > 1 ? resobj.ncomp * 1.065 : 2.1);
   const limX = $derived([xMin, xMax]);

   const xValues = $derived(resobj ? resobj.stat.components : null);
   const yValues = $derived(resobj ? vector(resobj.stat[statName]) : null);
   const labels = $derived(yValues ? Array.from(yValues.v).map(v => v < 0.1 ? v.toFixed(3) : v.toFixed(2)) : null);
   const limY = $derived(yValues ? [Math.min(-0.1, min(yValues)), 1.1] : [0,1.1]);
</script>

{#if xValues && yValues }
<Axes {title} {limX} {limY} fileName={'plot-' + statName} whole={true}>

   <!-- data points  -->
   <PlotSeries
      {xValues}
      {yValues}
      {labels}
      plotType={params.plotType}
      showLabels={params.showLabels}
      faceColor={FACE_COLORS['cal']}
      lineWidth={1.5}
   />

   <XAxis showGrid={true} label='Number of PCs' whole={true} />
   <YAxis showGrid={true} label='Variance' />
   <Box />
</Axes>
{/if}